import {getToken} from "@/scripts/Common";
import {roles} from "@/Enums";
import jwt_decode from "jwt-decode";
import {Claims} from "@/authorization/constants/JwtClaimConstants";

const getRoleClaims = () => Object.values(jwt_decode(getToken()))[Claims.userRoles] as string[];

const hasAccessRights = (allowedRoles: roles[]) => {
  const userRoleClaims = getRoleClaims();
  return  allowedRoles.some((role) => userRoleClaims.includes(role))
}

const getCurrentLoggedInUsername = () => Object.values(jwt_decode(getToken()))[Claims.userName] as string ?? '';

export {
  hasAccessRights,
  getCurrentLoggedInUsername
}
